export const NO_COUNTRY = '';

const SEP = '\u001f';

export const cityKey = (country: string, city: string): string =>
  `${country}${SEP}${city}`;

export const cityKeys = (countries: string[], city: string): string[] =>
  city === '' ? [] : countries.map((country) => cityKey(country, city));
